module.exports = __webpack_public_path__ + "img/not-play.cf7e1199.png";